<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-appeal__appeal">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item prop="schoolId" v-if="$hasPermission('admin:admin:student')">
          <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable>
            <el-option
                    v-for="school in schoolList"
                    :value="school.id"
                    :label="school.schoolName"
                    :key="school.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.className" placeholder="班级名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.state" placeholder="状态" clearable filterable>
                        <el-option label="审核中" :value=appeal.WAIT></el-option>
                        <el-option label="审核通过" :value=appeal.YES></el-option>
                        <el-option label="驳回" :value=appeal.NO></el-option>
                    </el-select>
        </el-form-item>
        <el-form-item>
                    <el-date-picker
                            v-model="appealDate"
                            type="daterange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-form-item>
        <el-form-item>
          <el-button @click="getPage()">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="className" label="班级" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="reason" label="申诉原因" header-align="center" align="center"></el-table-column>
        <el-table-column prop="appealDate" label="申诉时间" header-align="center" align="center"></el-table-column>
          <el-table-column prop="imgSrc" label="图片" header-align="center" align="center">
              <template slot-scope="scope">
                  <div v-if="scope.row.imgSrc">
                      <el-image
                              :src="scope.row.imgSrc"
                              :preview-src-list="[scope.row.imgSrc]"
                              fit="contain"
                              style="max-width: 100px; max-height: 100px;"
                      />
                  </div>
                  <div v-else>
<!--                      图片为空-->
                  </div>
              </template>
          </el-table-column>
        <el-table-column prop="state" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === appeal.WAIT" size="small" type="danger"
                    effect="dark">
              审核中
            </el-tag>
            <el-tag v-else-if="scope.row.state === appeal.YES" size="small" type="success"
                    effect="dark">
              审核通过
            </el-tag>
            <el-tag v-if="scope.row.state === appeal.NO" size="small" type="danger"
                    effect="dark">
              已驳回
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="auditDate" label="审核时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="auditReason" label="审核原因" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('appeal:appeal:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">申诉</el-button>
            <el-button v-if="$hasPermission('appeal:appeal:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './appeal-add-or-update'
import { appeal } from '@/constant'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      appeal,
      mixinViewModuleOptions: {
        getDataListURL: '/appeal/appeal/page',
        getDataListIsPage: true,
        exportURL: '/appeal/appeal/export',
        deleteURL: '/appeal/appeal',
        deleteIsBatch: true
      },
      schoolList: [],
      appealDate: [],
      dataForm: {
        schoolId: ''
      }
    }
  },
  watch: {
  },
  mounted () {
    this.getSchoolList()
  },
  methods: {
    getPage () {
      if (this.appealDate === null || this.appealDate.length <= 1) {
        this.dataForm.startTime = ''
        this.dataForm.endTime = ''
        this.appealDate = []
        return this.getDataList()
      }
      const date = new Date(this.appealDate[0])
      this.dataForm.startTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + '00:00:00'
      const date2 = new Date(this.appealDate[1])
      this.dataForm.endTime = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate() + ' ' + '23:59:59'
      this.getDataList()
    },
    // 获取学校集合
    getSchoolList () {
      this.$http.get('school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      })
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
